import type { WorkHistoryDailyStat } from "./useWorkHistorySummaryQuery";

export interface WorkHistoryStatSummary {
  /** 선택 기간의 날짜 수. BE가 범위 내 모든 날짜를 zero-filled 행으로 채워 보내므로
   *  (`StatisticsService.get_period_summary`) 서로 다른 날짜 수가 기간의 전체 일수다. */
  totalDays: number;
  /** 일지가 하나 이상 있는 날짜 수. */
  loggedDays: number;
  missingDays: number;
  /** 실제 일지가 있는 날짜 기준 일 평균, 소수 첫째자리. 기록된 날짜가 없으면 "0.0". */
  avgWorkforcePerLoggedDay: string;
  avgEquipmentPerLoggedDay: string;
}

/**
 * 기간 통계 카드의 보조 문구(footer)·"Log Submission" 카드에 쓰는 파생값.
 * 새 API 호출이나 필드 없이 이미 받아온 `daily_stats`만으로 계산한다.
 * 같은 날짜에 일지가 여럿이면 행도 여럿 온다(`docs/Bricks-Handoff/product/api-contract.md` §4).
 * 그래서 행 수가 아니라 서로 다른 날짜 수로 센다.
 */
export function computeWorkHistoryStatSummary(
  dailyStats: WorkHistoryDailyStat[],
  totalWorkforce: number,
  totalEquipment: number,
): WorkHistoryStatSummary {
  const totalDays = new Set(dailyStats.map((stat) => stat.date)).size;
  const loggedDays = new Set(dailyStats.filter((stat) => stat.daily_log_id !== null).map((stat) => stat.date)).size;
  const average = (value: number) => (loggedDays > 0 ? (value / loggedDays).toFixed(1) : "0.0");

  return {
    totalDays,
    loggedDays,
    missingDays: totalDays - loggedDays,
    avgWorkforcePerLoggedDay: average(totalWorkforce),
    avgEquipmentPerLoggedDay: average(totalEquipment),
  };
}
